import * as React from "react";

function SvgWebEngage(props, ref) {
  return (
    <svg
      id="WebEngage_svg__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 205 188.7"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".WebEngage_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#eaeaea}"
        }
      </style>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#333"
        stroke="#231f20"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        d="M0 0h205v188.7H0z"
      />
      <g id="WebEngage_svg__B1meWH_1_">
        <path
          className="WebEngage_svg__st1"
          d="M197.2 108.7c-6.2 3-12 5.8-18 8.7-6.3-4.8-12.7-9.6-18.9-14.6-3.1-2.5-6.3-3.6-10.4-3.8-14.1-.9-27.6-4.4-38.8-13.7-7.9-6.6-13.1-15-17.1-24.2-3.9-9.1-6-18.6-7.2-28.4-.4-3.6-.5-3.7-4.1-4.5-6.5-1.4-12.9-2.8-19.6-4.2.6-2.7 2.6-3.3 4.5-3.6 5.2-.8 10.5-1.7 15.8-2 3.2-.2 5.5-.9 7.6-3.7 7.2-9.8 21.2-8 26.9.5 10.2 15 20.5 29.9 30.6 45 5.5 8.1 10.8 16.4 16 24.7 1.4 2.2 3 3.9 5.1 5.3 8 5.3 16.1 10.7 24.1 16.1 1 .5 2 1.3 3.5 2.4zM129.3 40c-4.9 2.6-8.5 5.9-11.6 9.9-5 6.5-5.1 13-.4 19.8 5.4 7.7 13.1 9.8 21.9 8.2 3.8-.7 7.8-1.4 11-4.4-5.3-8.6-10.6-17-15.8-25.5-1.7-2.6-3.3-5.1-5.1-8zm-22.4-18.9c.1-1.9-1.1-3.1-3-3.2-1.9-.1-3.2 1.2-3.2 3s1.2 3.2 3 3.2c1.9 0 3.2-1.2 3.2-3zM45.7 129.1c-2.2-1.1-1.6-2.9-1.7-4.5-.1-1.6 0-3.2 0-5.2H8.6c-1.2-3.1-.5-6.1-.6-9-.1-2.8 0-5.6 0-8.7 4.1-1 8-.4 11.9-.5 3.8-.1 7.7 0 11.5 0h12.1c.9-2.5.3-4.8.5-7.1.3-2.8 1.6-3.6 3.9-1.9 4.4 3.2 8.8 6.6 13.2 9.9 2.7 2 5.4 3.9 8 6 2.3 2 2.4 3.6 0 5.3-7.2 5.1-14.4 10.1-21.7 15.1-.6.3-1.3.4-1.7.6zM30.2 73.2c-1.5 2.5.6 5.8-2.7 7.8-6.7-4.5-13.7-8.8-20.3-14.6 6.7-6.3 13.8-11 20.6-16 2.8 2.3 1.1 5.3 2.3 8 1.4.1 2.8.2 4.3.2h39.5c1.3 0 2.7-.1 4 .1 4.2.5 6.9 3.3 6.9 7.1s-2.7 6.6-6.9 7.2c-1.3.2-2.7.1-4 .1h-39c-1.6-.1-3.3 0-4.7.1zM30 160.1c-.4 2.9-.8 5.3-1.1 7.8-3.9-.9-15.6-8.7-21.1-14 .5-.8.9-2 1.7-2.7 5.7-4.4 11.4-8.6 17.2-12.9.4-.3.9-.2 1.5-.3 2.7 2 .7 5.1 2 7.8 1.2.1 2.6.2 4.1.2h42.5c2.4 0 4.6.1 6.3 2.3 3.5 4.4 1.3 10.5-4.2 11.6-1.3.3-2.7.1-4 .1h-40c-1.7.1-3.3.1-4.9.1z"
        />
        <path
          className="WebEngage_svg__st1"
          d="M159.2 70.5c-7.4-11.4-14.7-22.6-22.1-33.9 4.9-4.1 10.4-6.4 16.4-7.2 8.2-1.2 15.6 4.3 18.3 13 1.4 4.7 1.1 9.2-.8 13.6-2.6 5.7-6.3 10.5-11.8 14.5z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgWebEngage);
